'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.filter-tabs').length <= 0 ) {
        return
    }

    $('.filter-tabs__item').on('click', function () {
        $('.filter-tabs').removeClass('active-left active-right');
        $('.filter-tabs__item').removeClass('active');
        $(this).addClass('active');

        $('.filter-tabs').addClass(`active-${$(this).data('direction')}`);
        $('.tab-content').addClass('disabled');
        $(`#tab-${$(this).data('tab')}`).removeClass('disabled');
    });
}
